import actions from '@ehi/global-marketing-interface/lib/actions';
import services from '@ehi/global-marketing-interface/lib/services';

export const getCarClassDetails = (carClassCode) => (dispatch) =>
  dispatch(
    actions.request({
      service: services.gma.reservations.carClassDetails,
      data: { params: { carClassCode } },
    })
  );
